import styled, { keyframes } from 'styled-components/macro';

const SpinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  width: 58px;
  height: 58px;
  border: 7px solid #9de2ff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: ${SpinAnimation} 1s linear infinite;
  z-index: 500;
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

export const SpinnerWrapper = styled.div<{ center?: boolean }>`
  z-index: 300;
  position: ${(props) => (props.center ? 'static' : 'absolute')};
  margin: auto;
  left: 0;
  right: 0;
  //top: 150px;
  top: ${(props) => (props.center ? '0' : '150px')};
  //bottom: 0;
`;

export const FadeWrapper = styled.div`
  width: inherit;
  position: relative;
  height: -webkit-fill-available; //TODO: надо?
  height: -moz-available; //TODO: надо?
  width: -webkit-fill-available;
  width: -moz-available;
  overflow-y: hidden;
  z-index: 400;
  pointer-events: none;
`;

export const Child = styled.div<{ page?: string }>`
  z-index: 1;
  opacity: ${(props) => (props.page === 'requestsList' ? '' : '0.3')};

  & > div > div {
    opacity: ${(props) => (props.page === 'requestsList' ? '0.3' : '')};
  }
`;
